<template>
  <v-container grid-list-xl>
    <v-layout wrap v-if="toolPickup">
      <v-flex xs12>
        <!-- back to pickups -->
        <v-btn class="mr-4 mb-2" small text color="primary" to="/tools/pickups">
          <v-icon small class="mr-1">chevron_left</v-icon>Pickups
        </v-btn>

        <!-- cancel order -->
        <v-dialog v-model="cancelPickupDialog" width="600">
          <template v-slot:activator="{ on }">
            <v-btn
              v-if="toolPickup.status == 'open'"
              dark
              small
              color="grey darken-2"
              class="mr-4 mb-2"
              v-on="on"
              @click="cancelPickupDialog = true"
            >
              <v-icon small class="mr-2">cancel</v-icon>Cancel Pickup
            </v-btn>
          </template>

          <v-card class="pa-4">
            <v-card-title class="title lighten-2" primary-title>
              Cancel Pickup
            </v-card-title>

            <v-card-text>
              Are you sure you want to cancel this pickup?
              <br />The foreman will be notified that the pickup was cancelled.
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="cancelPickupDialog = false"
                >Cancel</v-btn
              >
              <v-btn color="primary" @click="cancelPickup">
                Cancel Pickup
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- download pdf -->
        <v-btn
          class="float-right mb-2"
          small
          color="primary"
          @click="downloadPDF"
        >
          <v-icon small class="mr-1">picture_as_pdf</v-icon>Download PDF
        </v-btn>
      </v-flex>
      <!--  tool order details-->
      <v-flex xs12>
        <tool-pickup-details
          v-if="toolPickup"
          :toolPickup="toolPickup"
          :admin="false"
        />
      </v-flex>

      <!-- tool list -->
      <v-flex xs12>
        <v-card v-if="toolPickup">
          <v-simple-table>
            <thead>
              <tr>
                <th class="text-left" width="100"></th>
                <th class="text-left">Name</th>
                <th class="text-center" width="80">On Site</th>
                <th class="text-center" width="100">Requested</th>
                <th class="text-center" width="160">Received</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="tool in toolPickup.tools" :key="tool.id">
                <td class="pa-4">
                  <v-img :src="tool.image" width="50" height="50" contain />
                </td>
                <td>
                  {{ tool.title }}
                </td>
                <td class="text-center">
                  {{ tool.totalQty }}
                </td>
                <td class="text-center">
                  {{ tool.pickupQty }}
                </td>
                <td>
                  <div class="text-center">
                    {{ tool.returnedQty }}
                  </div>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card>
        <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
          {{ snackText }}
          <v-btn text @click="snack = false">Close</v-btn>
        </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import fb from "@/main";
import { mapState } from "vuex";
import toolPickupDetails from "@/components/toolPickups/ToolPickupDetails";
export default {
  components: {
    toolPickupDetails,
  },
  data() {
    return {
      search: "",
      snack: false,
      snackColor: "",
      snackText: "",
      toolPickup: null,
      returnDialog: false,
      cancelPickupDialog: false,
      returnNote: "",
    };
  },
  methods: {
    downloadPDF() {
      const url = `https://us-central1-alba-demolition.cloudfunctions.net/toolPickupGeneratePDF?orderNumber=${this.$route.params.orderNumber}`;
      window.open(url, "_blank");
    },
    async getOrder() {
      try {
        let toolPickup = await fb.db
          .collection("toolPickups")
          .doc(this.$route.params.orderNumber)
          .get();
        toolPickup = toolPickup.data();
        toolPickup.tools.forEach((tp) => {
          if (!tp.returnedQty) {
            tp.returnedQty = 0;
          }
        });
        this.toolPickup = toolPickup;
        console.log(this.toolPickup);
      } catch (error) {
        alert("Error getting orders.");
        console.log(error);
      }
    },
    async cancelPickup() {
      await fb.db
        .collection("toolPickups")
        .doc(this.$route.params.orderNumber)
        .update({
          status: "cancelled",
        });
      this.cancelPickupDialog = false;
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Successfully Cancelled Pickup!";
      this.getOrder();
    },
  },
  computed: {
    ...mapState(["user"]),
  },
  async created() {
    this.getOrder();
  },
};
</script>

<style scoped>
.fulfillment-input {
  margin-bottom: -20px;
}
</style>
